document.addEventListener('DOMContentLoaded', function () {
  /*
   * ============================================================
   * Certificate Gallery
   * ============================================================
   */

  const gallery = document.querySelector('.certificate-gallery');

  if (!gallery) {
    return;
  }

  /*
   * ============================================================
   * Elements
   * ============================================================
   */

  const previewModal = document.querySelector(
    '[data-certificate-preview-modal]'
  );

  const requestModal = document.querySelector(
    '[data-certificate-modal]'
  );

  const formSource = document.querySelector(
    '[data-certificate-form-source]'
  );

  const formMount = requestModal
    ? requestModal.querySelector('[data-certificate-form-mount]')
    : null;

  /*
   * ============================================================
   * State
   * ============================================================
   */

  let lastFocusedElement = null;

  /*
   * ============================================================
   * Utility
   * ============================================================
   */

  function lockBodyScroll() {
    document.body.classList.add('certificate-modal-open');
  }

  function unlockBodyScroll() {
    /*
     * Only remove our class.
     * Do not interfere with any other body classes.
     */
    document.body.classList.remove('certificate-modal-open');
  }

  function focusElement(element) {
    if (!element) {
      return;
    }

    window.setTimeout(function () {
      try {
        element.focus();
      } catch (error) {
        // Ignore focus errors.
      }
    }, 50);
  }

  /*
   * ============================================================
   * Move Forms - Opal Infotech form into request modal
   * ============================================================
   *
   * The app block is rendered by Shopify inside:
   *
   * .certificate-gallery__form-source
   *
   * We move that existing DOM node into:
   *
   * [data-certificate-form-mount]
   *
   * This does NOT recreate the form and does NOT submit it.
   * The Forms app continues to own the actual form functionality.
   */

  if (formSource && formMount) {
    formMount.appendChild(formSource);
    formSource.removeAttribute('data-certificate-form-source');
  }

  /*
   * ============================================================
   * Certificate Preview
   * ============================================================
   */

  function openPreview(button) {
    if (!previewModal || !button) {
      return;
    }

    const image = previewModal.querySelector(
      '[data-preview-image]'
    );

    if (!image) {
      return;
    }

    const previewSrc = button.getAttribute(
      'data-preview-src'
    );

    const certificateTitle = button.getAttribute(
      'data-certificate-title'
    ) || 'Certificate Preview';

    if (!previewSrc) {
      return;
    }

    lastFocusedElement = button;

    image.src = previewSrc;
    image.alt = certificateTitle;

    previewModal.hidden = false;

    /*
     * Allow CSS transitions to run.
     */
    requestAnimationFrame(function () {
      previewModal.classList.add('is-open');
    });

    lockBodyScroll();

    const closeButton = previewModal.querySelector(
      '.certificate-preview-modal__close'
    );

    focusElement(closeButton);
  }

  function closePreview() {
    if (!previewModal) {
      return;
    }

    previewModal.classList.remove('is-open');

    /*
     * Keep the transition smooth before hiding.
     */
    window.setTimeout(function () {
      if (!previewModal.classList.contains('is-open')) {
        previewModal.hidden = true;

        const image = previewModal.querySelector(
          '[data-preview-image]'
        );

        if (image) {
          image.removeAttribute('src');
          image.alt = '';
        }
      }
    }, 220);

    unlockBodyScroll();

    focusElement(lastFocusedElement);
  }

  /*
   * ============================================================
   * Certificate Request
   * ============================================================
   */

  function setCertificateField(certificate) {
    if (!requestModal) {
      return false;
    }

    const field = requestModal.querySelector(
      'input[name="certificate_requested"]'
    );

    if (!field) {
      return false;
    }

    field.value = certificate;

    /*
     * Notify the Forms app that the field changed.
     */
    field.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    field.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

    return true;
  }

  function populateCertificateField(certificate) {
    /*
     * The Forms app can render asynchronously.
     *
     * Try immediately and then retry briefly.
     */
    if (setCertificateField(certificate)) {
      return;
    }

    let attempts = 0;

    const interval = window.setInterval(function () {
      attempts++;

      if (
        setCertificateField(certificate) ||
        attempts >= 20
      ) {
        window.clearInterval(interval);
      }
    }, 100);
  }

  function openRequest(button) {
    if (!requestModal || !button) {
      return;
    }

    const certificate = button.getAttribute(
      'data-certificate'
    ) || '';

    const selectedCertificate =
      requestModal.querySelector(
        '[data-selected-certificate]'
      );

    if (selectedCertificate) {
      selectedCertificate.textContent = certificate;
    }

    /*
     * Make sure the hidden field receives the
     * certificate title.
     */
    populateCertificateField(certificate);

    lastFocusedElement = button;

    requestModal.hidden = false;

    requestAnimationFrame(function () {
      requestModal.classList.add('is-open');
    });

    lockBodyScroll();

    /*
     * Focus the first useful form field if available.
     * Otherwise focus the close button.
     */
    window.setTimeout(function () {
      const firstInput = requestModal.querySelector(
        'input:not([type="hidden"]), textarea, select'
      );

      if (firstInput) {
        focusElement(firstInput);
        return;
      }

      const closeButton =
        requestModal.querySelector(
          '.certificate-request-modal__close'
        );

      focusElement(closeButton);
    }, 100);
  }

  function closeRequest() {
    if (!requestModal) {
      return;
    }

    requestModal.classList.remove('is-open');

    window.setTimeout(function () {
      if (!requestModal.classList.contains('is-open')) {
        requestModal.hidden = true;
      }
    }, 220);

    unlockBodyScroll();

    focusElement(lastFocusedElement);
  }

  /*
   * ============================================================
   * Gallery click handling
   * ============================================================
   */

  gallery.addEventListener('click', function (event) {
    const previewButton =
      event.target.closest(
        '[data-certificate-preview]'
      );

    if (previewButton) {
      event.preventDefault();
      openPreview(previewButton);
      return;
    }

    const requestButton =
      event.target.closest(
        '[data-certificate-request]'
      );

    if (requestButton) {
      event.preventDefault();
      openRequest(requestButton);
    }
  });

  /*
   * ============================================================
   * Preview modal close
   * ============================================================
   */

  if (previewModal) {
    previewModal.addEventListener('click', function (event) {
      const closeTrigger =
        event.target.closest(
          '[data-preview-close]'
        );

      if (closeTrigger) {
        event.preventDefault();
        closePreview();
      }
    });
  }

  /*
   * ============================================================
   * Request modal close
   * ============================================================
   */

  if (requestModal) {
    requestModal.addEventListener('click', function (event) {
      const closeTrigger =
        event.target.closest(
          '[data-certificate-modal-close]'
        );

      if (closeTrigger) {
        event.preventDefault();
        closeRequest();
      }
    });
  }

  /*
   * ============================================================
   * ESC key
   * ============================================================
   */

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    if (
      previewModal &&
      !previewModal.hidden
    ) {
      closePreview();
      return;
    }

    if (
      requestModal &&
      !requestModal.hidden
    ) {
      closeRequest();
    }
  });

  /*
   * ============================================================
   * Prevent background interaction while modal is open
   * ============================================================
   *
   * CSS handles visual scroll locking.
   * This is just a safety measure for touch devices.
   */

  document.addEventListener(
    'touchmove',
    function (event) {
      const previewOpen =
        previewModal &&
        !previewModal.hidden;

      const requestOpen =
        requestModal &&
        !requestModal.hidden;

      if (previewOpen || requestOpen) {
        /*
         * Allow scrolling inside the modal dialog itself.
         */
        const insideDialog =
          event.target.closest(
            '.certificate-preview-modal__dialog, .certificate-request-modal__dialog'
          );

        if (!insideDialog) {
          event.preventDefault();
        }
      }
    },
    {
      passive: false
    }
  );
});